import React from "react";

const AnnouncementFR = () => {
  return (
    <div>
      <div className="announcement">
        <p>
          <b>Notre priorité est d'améliorer le service que nous vous offrons</b>
        </p>
        <div>
          <p><b>21 Octobre, 2024</b></p>
          <p>
            <b>
              Un message de MSH International pour les participants du RSSFP
            </b>
          </p>
          <p>
            <b>Nous répondons aux attentes du gouvernement du Canada</b>
          </p>
          <p>
            Dans notre
            <a
              href="https://www.bienvenue.canadavie.com/rssfp/msh/msh-mise-a-jour.html"
              className="link"
              target="_blank">
              mise à jour
            </a>
            précédente, nous vous avons informés qu'une
            transparence accrue concernant nos améliorations et nos niveaux de service
            constitue l'un des piliers du plan d'action de MSH en matière de service à
            la clientèle. Nous continuons d'améliorer l’expérience des participants et
            sommes heureux d’annoncer que les délais de traitement des demandes de
            règlement se sont grandement améliorés. Nous continuons de mettre l’accent
            sur la satisfaction constante des attentes du gouvernement du Canada en ce
            qui concerne les délais de traitement des demandes de règlement.
          </p>
          <p>
            Nous avons également augmenté le nombre d’agents au centre d’appels de MSH
            pour la garantie assistance voyage d’urgence et la protection totale. Cela a
            considérablement réduit le temps d’attente moyen, faisant en sorte que les
            participants du régime peuvent maintenant communiquer avec un agent du
            centre d’appels en deux ou trois minutes, que l’appel soit urgent ou non.
          </p>
          <p>
            Pour vérifier les temps d’attente actuels pour le traitement des demandes de
            règlement et le centre d’appels, veuillez consulter notre
            <a
              href="https://www.bienvenue.canadavie.com/rssfp/msh/tableau-de-bord-sur-le-service-de-msh.html"
              className="link"
              target="_blank"
            >
              tableau de bord de service de MSH.
            </a>
          </p>
          <p>
            Dans notre dernière mise à jour, nous avons également mentionné le lancement
            d’une expérience améliorée dans le portail de MSH pour les participants du
            RSSFP qui devrait faciliter et accélérer la création de votre compte,
            l’ouverture de session et la consultation de votre explication des
            prestations. Depuis, nous avons continué d’ajouter de nouvelles
            fonctionnalités pour mieux vous servir, telles que:
          </p>
          <ul>
            <li>
              Il est plus facile de trouver de l’information dans le portail, comme les
              coordonnées à utiliser et les renseignements sur les types de demandes de
              règlement traitées par MSH.
            </li>
            <li>
              Il est maintenant possible d’accéder aux documents importants à la
              nouvelle page Formulaires et documents importants.
            </li>
            <li>
              Vous avez accès à une section foire aux questions, qui fournit des
              réponses aux questions les plus fréquentes.
            </li>
            <li>
              Un nouveau processus de présentation des demandes de règlement a été mis
              en place pour les participants ayant la protection totale.
            </li>
          </ul>
          <p>
            Nous continuons de chercher des occasions d’améliorer le portail de MSH pour
            les participants du RSSFP afin d’offrir la meilleure expérience en ligne
            possible.
          </p>
          <p>
            De plus, le
            <a
              href="https://www.bienvenue.canadavie.com/rssfp/nouvelles-et-mises-a-jour/processus-de-transfert-aux-echelons-superieurs-pour-les-besoins-urgents.html"
              className="link"
              target="_blank"
            >
              processus de transfert aux échelons supérieurs pour les besoins urgents
            </a>
            demeure en place. Si votre demande de règlement concerne des médicaments sur
            ordonnance, des services ou des traitements qui sont urgents et essentiels à
            la vie, si vous êtes une personne ayant une invalidité ou si vous éprouvez
            des difficultés financières liées à une demande de règlement, sachez que
            votre demande de règlement sera traitée en priorité grâce à ce processus de
            transfert aux échelons supérieurs. Seules les demandes de règlement qui ont
            déjà été soumises à MSH peuvent être transférées aux échelons supérieurs.
          </p>
          <p>
            Si vous êtes dans une situation d’urgence médicale, vous pouvez communiquer
            avec notre centre d’appels en Amérique du Nord (sans frais) au 1 833
            774-2700 ou (à frais virés) au 1 365 337-7427 pour les appels
            internationaux. Appuyez sur le « 1 » pour que votre appel soit immédiatement
            acheminé à un agent. Veuillez ne pas utiliser cette option si votre appel
            n’est pas urgent ou si vous n’êtes pas en situation d’urgence.
          </p>
          <p>
            Si vous avez d’autres questions au sujet de notre plan d’action en matière
            de service à la clientèle, consultez notre
            <a
              href="https://www.bienvenue.canadavie.com/rssfp/msh/msh-mise-a-jour.html#faq"
              className="link"
              target="_blank"
            >
              Foire aux questions
            </a>
            pour obtenir des précisions.
          </p>
          <p>
            Nous vous remercions de votre patience pendant que nous continuons
            d’améliorer l’expérience des participants.
          </p>
          <p>Sincères salutations,</p>
          <p>MSH International</p>
        </div>

        <div>
          <p>
            <br />
            <b>24 Juillet, 2024</b>
            <p>
              <b>
                Le portail de MSH pour les participants du RSSFP a{" "}
                <u>été amélioré</u>
              </b>
              <p>
                Comme nous l’avons promis dans notre plan d’action en matière de
                service à la clientèle, nous sommes heureux de vous offrir une
                expérience améliorée dans le
                <a
                  className="link"
                  href="https://rssfp-msh.ca/"
                  target="_blank"
                >
                  portail de MSH pour les participants du RSSFP.
                </a>
              </p>
              <p>
                Le portail est maintenant plus facile à utiliser. Voici
                quelques-unes des améliorations qui ont été apportées:
              </p>
              <ul>
                <li>
                  Des pages d’inscription et d’ouverture de session révisées
                  pour accélérer la création de votre compte et l’ouverture
                  d’une session.
                </li>
                <li>
                  Un remaniement des pages de renvoi pour faciliter la recherche
                  de renseignements importants, comme les coordonnées et les
                  renseignements sur les types de demandes de règlement traitées
                  par MSH.
                </li>
                <li>
                  Un processus de soumission des demandes de règlement en ligne
                  amélioré pour les participants bénéficiant de la protection
                  totale.
                </li>
                <li>
                  La capacité de consulter l’historique de vos demandes de
                  règlement et vos détails de règlements en ligne, afin que vous
                  ayez accès aux plus récentes mises à jour sur les
                  remboursements lorsque vous en avez besoin.
                </li>
                <li>
                  Une nouvelle page Formulaires et documents importants pour
                  accéder rapidement aux documents dont vous avez besoin.
                </li>
                <li>
                  Un lien vers une Foire aux questions (FAQ) dans laquelle vous
                  trouverez les réponses à vos questions les plus pressantes.
                </li>
              </ul>
              <br />
              <p>
                Au plaisir de mieux vous servir!
                <p>Merci,</p>
                <p>MSH International</p>
              </p>
            </p>
            <br />
            <b>14 mai, 2024</b>
          </p>
          <p>
            Dans notre dernière
            <a
              href="https://www.bienvenue.canadavie.com/rssfp/msh/msh-mise-a-jour.html"
              className="link"
              target="_blank"
            >
              mise à jour,
            </a>
            nous vous avons fait savoir qu’une transparence accrue est l’un des
            principaux piliers du plan d’action pour le service à la clientèle
            de MSH. Nous reconnaissons qu’il y a certains points que nous devons
            améliorer. Sachez qu’à mesure que nous y travaillons et que nous
            réalisons des progrès, vous serez informé des mesures prises.
          </p>
          <p>
            Fidèles à notre engagement de transparence, nous avons le plaisir de
            vous présenter un
            <a
              href="https://www.bienvenue.canadavie.com/rssfp/msh/tableau-de-bord-sur-le-service-de-msh.html"
              className="link"
              target="_blank"
            >
              tableau de bord sur les services de MSH
            </a>
            remanié. En plus d’y indiquer le temps moyen de traitement des
            demandes de règlement, nous y affichons désormais le temps d’attente
            moyen estimé au centre d’appels, tant pour les appels au sujet de
            l’Assistance voyage d’urgence que pour les appels au sujet de la
            protection totale. Le tableau de bord sera mis à jour chaque semaine
            afin que vles informations les plus récentes sur l'expérience vous
            soient fournies.
          </p>
          <p>
            Nous avons également le plaisir d’annoncer le lancement d’une série
            d’améliorations visant le
            <a href="https://rssfp-msh.ca/" target="_blank" className="link">
              portail de MSH pour les participants du RSSFP.
            </a>
            Le portail offre maintenant une expérience en ligne actualisée.
            Voici quelques-unes des nouvelles caractéristiques :
            <ul>
              <li>
                une page d’inscription et d’ouverture de session pour accéder au
                portail en ligne qui a été améliorée pour faciliter la création
                et la consultation de votre compte.
              </li>
              <li>
                la possibilité de consulter l’historique de vos demandes de
                règlement et relevés d’explication des prestations en ligne.
              </li>
            </ul>
          </p>

          <p>
            Grâce à ces améliorations apportées au portail, nous constatons une
            diminution du temps d’attente des appels, car vous avez maintenant
            accès à l’historique de vos demandes de règlement au bout des
            doigts.
          </p>

          <p>
            Nous reconnaissons qu'il faudra peut-être un certain temps pour que
            les membres du RSSFP ressentent les avantages de nos améliorations.
            Nous avons pour priorité l’ajout, à nos équipes, d’agents du service
            à la clientèle et de préposés aux traitements des demandes de
            règlement afin d’améliorer notre temps de réponse et votre
            expérience globale à titre de participant. Nous surveillons nos
            progrès et modifierons notre Plan d’action en matière de service à
            la clientèle en conséquence pour que les retards et temps d’attente
            continuent de diminuer.
          </p>

          <p>
            Si vous avez des questions au sujet de notre plan d’action en
            matière de service à la clientèle, nous vous invitons à consulter
            notre dernière
            <a
              href="https://www.bienvenue.canadavie.com/rssfp/msh/msh-mise-a-jour.html"
              className="link"
              target="_blank"
            >
              mise à jour ainsi que la foire aux questions
            </a>
            pour en savoir plus.
          </p>

          <p>
            Nous vous remercions de votre patience et de votre compréhension
            pendant que nous apportons les changements nécessaires dans le but
            d’améliorer votre expérience.
          </p>
          <p>Sincères salutations,</p>
          <p>MSH International</p>
        </div>
        <br />
        <b>
          Chez MSH International (MSH), il est important pour nous que vous ayez
          un accès fiable à vos prestations de soins de santé lorsque vous en
          avez besoin.
        </b>
        <br />
        Depuis le transfert de la garantie assistance voyage d’urgence et de la
        protection totale du Régime de soins de santé de la fonction publique
        (RSSFP) à MSH, l’expérience des participants n’est pas à la hauteur des
        normes de service que nous nous sommes fixées. Soyez assurés que nous
        sommes résolus à faire mieux.
        <p>
          Lorsque le RSSFP a été transféré à MSH le 1er juillet 2023, MSH a reçu
          un nombre important de demandes de règlement qui nécessitaient une
          attention immédiate. Cette situation a causé un retard dans le
          traitement des demandes de règlement, qui s’est par la suite aggravé
          en raison du cyberincident subi plus tôt cette année. Soyez assuré que
          nous travaillons fort pour améliorer les délais de traitement pour
          vous.
        </p>
        Pour que votre expérience en tant que participant de régime s’améliore
        plus rapidement, nous procédons à la mise en œuvre d’un plan d’action
        pour le service à la clientèle qui est axé sur trois priorités
        essentielles :
        <p>
          <ul>
            • Réduire le temps d’attente au centre d’appels
            <br />
            • Améliorer le délai de traitement des demandes de règlement
            <br />
            • Établir un processus pour s’assurer que les cas urgents sont
            transférés aux échelons supérieurs de manière appropriée
            <br />
          </ul>
        </p>
        <br />
        <b>Que pouvez-vous attendre de nous?</b>
        <br />
        Dans le cadre de notre plan d’action pour le service à la clientèle,
        vous pouvez compter sur :
        <p>
          <ul>
            <b>• Un temps d’attente au centre d’appels plus court</b>
            <br />
            Nous ajoutons chaque jour plus d’agents au centre d’appels, et le
            temps d’attente diminue. Le temps d’attente moyen pour les appels
            urgents ou concernant des situations d’urgence est de 5 minutes, et
            nous travaillons fort à réduire le temps d’attente moyen pour les
            appels non urgents. Grâce au processus de recrutement en cours, nous
            prévoyons que les temps de réponse continueront de s’améliorer au
            cours des prochaines semaines.
            <b>
              • Un délai de traitement des demandes de règlement plus rapide
            </b>
            <br />
            Bien que nous ayons déjà traité plus de 17 000 demandes de
            règlement, nous augmentons rapidement le nombre d’agents
            responsables du traitement des demandes de règlement afin de réduire
            le retard et améliorer le délai de traitement des nouvelles demandes
            de règlement.
            <p>
              <b>
                • Le transfert des cas urgents et prioritaires aux échelons
                supérieurs
              </b>
              <br />
              Certaines situations nécessitent une attention immédiate. Nous
              avons recours au
              <u>
                <a
                  href="https://www.bienvenue.canadavie.com/rssfp/nouvelles-et-mises-a-jour/processus-de-transfert-aux-echelons-superieurs-pour-les-besoins-urgents.html"
                  className="link"
                  target="_blank"
                >
                  processus de transfert aux échelons supérieurs pour les
                  besoins urgents
                </a>
              </u>
              de la Canada Vie pour nous assurer que les demandes de règlement
              et les questions urgentes sont ciblées et traitées en priorité par
              nos équipes.
            </p>
            Si votre demande de règlement concerne des médicaments sur
            ordonnance, des services ou des traitements qui sont urgents et
            essentiels à la vie, si vous êtes une personne ayant une invalidité
            ou si vous éprouvez des difficultés financières liées à une demande
            de règlement, sachez que votre demande de règlement sera traitée en
            priorité grâce à ce processus de transfert aux échelons supérieurs.
            Seules les demandes de règlement qui ont déjà été soumises à MSH
            International (MSH) peuvent être transférées aux échelons
            supérieurs.
            <p>
              Si vous êtes dans une situation d’urgence médicale, vous pouvez
              communiquer avec notre centre d’appels en Amérique du Nord (sans
              frais) au 1 833 774-2700 ou (à frais virés) au 1 365 337-7427 pour
              les appels internationaux. Appuyez sur le « 1 » pour que votre
              appel soit immédiatement acheminé à un agent. Veuillez ne pas
              utiliser cette option si votre appel n’est pas urgent ou si vous
              n’êtes pas en situation d’urgence.
            </p>
            <b>• Une transparence accrue</b>
            <br />
            Nous avons ajouté un tableau
            <u>
              <a
                href="https://www.bienvenue.canadavie.com/rssfp/msh/tableau-de-bord-sur-le-service-de-MSH"
                className="link"
                target="_blank"
              >
                de bord sur le service de MSH
              </a>
            </u>
            qui présente le temps d’attente moyen au centre d’appels ainsi que
            le délai de traitement moyen des demandes de règlement. Nous avons
            aussi ajouté une
            <u>
              <a
                href="https://www.bienvenue.canadavie.com/rssfp/msh/msh-mise-a-jour.html"
                className="link"
                target="_blank"
              >
                foire aux questions
              </a>
            </u>
            qui contient de plus amples renseignements. Nous mettrons ces deux
            documents à jour à mesure que les temps d’attente s’amélioreront.
            <p>
              <b>
                • Une expérience améliorée dans le portail pour les participants
              </b>
              <br />
              Un nouveau portail de MSH pour les participants du RSSFP amélioré
              sera lancé bientôt. Nous travaillons à apporter des améliorations
              qui vous permettront d’accéder à une page d’inscription simplifiée
              et de consulter l’historique de vos demandes de règlement auprès
              de MSH, l’état des demandes de règlement ainsi que les relevés
              d’explication des prestations en ligne. Si vous n’avez pas encore
              créé de compte, nous vous recommandons de le faire afin de
              profiter d’une expérience numérique améliorée pour la soumission
              des demandes de règlement et la vérification de leur état en tout
              temps, peu importe où vous êtes.
            </p>
          </ul>
        </p>
        <br />
        <b>Notre engagement envers vous </b>
        <br />
        Chez MSH, il est important pour nous que vous ayez un accès fiable à vos
        prestations de soins de santé, que vous viviez et travailliez à
        l’extérieur du Canada ou que vous voyagiez.
        <p>
          Nous avons encore des progrès à faire, et nous poursuivons la mise en
          œuvre de notre plan d’action pour le service à la clientèle afin
          d’améliorer nos services pour vous.
        </p>
        Nous vous remercions pour votre patience et votre compréhension.
      </div>

      <p>
        <div className="announcement">
          <div>
            <p>
              <b>Le point sur le cyberincident de MSH</b>
            </p>
            <p>
              <b>21 mai, 2024</b>
            </p>
            <p>À tous les participants du RSSFP,</p>

            <p>
              En février, nous avons pris l’engagement de faire le point avec
              vous au sujet du cyberincident dont MSH a fait l’objet. Nous
              sommes heureux de vous informer que l’enquête est maintenant
              terminée. Comme vous vous le rappellerez, après que nous avons été
              informés du cyberincident, nous avons immédiatement pris des
              mesures avec la Canada Vie pour contenir l’incident et enquêter
              sur celui-ci. Ensemble, nous avons conçu un plan visant à
              restaurer le service et renforcé la sécurité de nos systèmes afin
              de protéger vos renseignements personnels.
            </p>

            <p>
              L’enquête nous a permis de découvrir que des renseignements
              personnels d’un très petit nombre de participants du régime ont
              été touchés. Nous avons déjà communiqué directement avec ces
              personnes pour les informer des étapes suivantes.
            </p>

            <p>
              Nous tenons à vous rassurer que malgré la possibilité accrue des
              cybermenaces dans le monde numérique actuel, notre priorité
              absolue consiste à protéger vos renseignements personnels. Nous
              demeurons vigilants pour faire tout ce qui est possible afin de
              veiller à la sécurité de vos renseignements.
            </p>

            <p>
              Pour relever encore davantage le niveau de protection de vos
              renseignements personnels, envisagez les
              <a
                href="https://www.canadalife.com/fr/securite-internet.html"
                className="link"
                target="_blank"
              >
                pratiques exemplaires de la Canada Vie en matière de sécurité
                internet.
              </a>
            </p>

            <p>
              Merci et n’hésitez pas à
              <a href="https://rssfp-msh.ca/" className="link" target="_blank">
                communiquer
              </a>
              avec nous si vous avez des questions au sujet de votre compte de
              MSH.
            </p>

            <p>MSH International</p>
          </div>
          <p>
            <br />
            <b>27 février, 2024</b>
          </p>
          <p>
            Nous avons le plaisir d’annoncer la reprise de tous les services de
            MSH International (MSH), y compris le portail de MSH pour les
            participants du RSSFP et les systèmes de traitement des demandes de
            règlement. Vous pouvez ouvrir une session dans votre compte du
            portail de MSH pour les participants du RSSFP pour soumettre à
            nouveau vos demandes de règlement en ligne en toute sécurité.
          </p>
          Avant la reprise des services, nous avons renforcé nos contrôles de
          sécurité et effectué des tests approfondis pour assurer un
          rétablissement en toute sécurité. Bien que le portail soit rétabli,
          notre enquête se poursuit. Soyez assurés que notre priorité demeure la
          protection de vos renseignements personnels. S’il s’avère qu’une
          personne a été touchée par cet incident, MSH l’en informera
          directement.
          <p>
            Vous pourrez recevoir des remboursements ou des communications de
            MSH concernant des demandes de règlement que vous avez soumises
            précédemment. Les remboursements et les communications provenant
            d’adresses courriel officielles de MSH, telles que
            <a href="mailto:assistances@rssfp-msh.ca" target="_blank" className="link">
              assistances@rssfp-msh.ca,
            </a>
            <a href="mailto:reclamation@rssfp-msh.ca" target="_blank" className="link">
              reclamation@rssfp-msh.ca
            </a>
            et verification-
            <a href="mailto:audit@rssfp-msh.ca" target="_blank" className="link">
              audit@rssfp-msh.ca,
            </a>
            ainsi que les courriels de “Proofpoint Essentials”, peuvent être
            reconnus comme des comptes authentiques et sécuritaires.
          </p>
          En raison du volume de demandes de règlement plus élevé que prévu, les
          délais de traitement sont plus longs que d’habitude. Nous travaillons
          à améliorer cette situation et avons investi dans du personnel
          supplémentaire pour aider à répondre à la demande.
          <p>
            Si votre demande de règlement concerne un médicament sur ordonnance,
            un service ou un traitement urgent et essentiel à la vie, si vous
            êtes une personne ayant une invalidité ou si vous éprouvez des
            difficultés financières en lien avec votre demande de règlement,
            veuillez suivre le
            <u>
              <a
                href="https://www.bienvenue.canadavie.com/rssfp/nouvelles-et-mises-a-jour/processus-de-transfert-aux-echelons-superieurs-pour-les-besoins-urgents.html"
                target="_blank"
                className="link"
              >
                processus de transfert aux échelons supérieurs pour les besoins urgents.
              </a>
            </u>
          </p>
          <p>
            Nous sommes sincèrement désolés de tout inconvénient causé par cette
            interruption de service inattendue et nous vous remercions pour
            votre patience et votre compréhension. De plus amples renseignements
            vous seront communiqués sur la façon dont nous travaillons pour
            améliorer les délais de service pour vous.
          </p>
          <p>Merci,</p>
          <p>MSH International</p>
          <br />
          <hr />
          <br />
          <p>
            <strong>12 février, 2024</strong>
          </p>
          <p>
            MSH International, le fournisseur du RSSFP pour la garantie
            assistance voyage d’urgence et la protection totale par
            l’intermédiaire de la Canada Vie, a récemment subi un cyberincident
            qui a entraîné des répercussions sur le service pour certains
            participants.
            <br />
          </p>
          <p>
            La Canada Vie et MSH prennent la situation très au sérieux. Nous
            collaborons avec MSH, qui étudie l’ampleur des répercussions de
            l’incident et élabore un plan pour rétablir le service et minimiser
            les risques relativement aux renseignements qui vous concernent. La
            priorité est de protéger vos renseignements et de veiller à ce que
            l’environnement des systèmes soit sécuritaire avant de rétablir
            l’accès au portail.
          </p>
          <p>
            En raison de l’incident, le portail de MSH pour les participants du
            RSSFP n’est pas accessible et MSH n’est pas en mesure de traiter les
            demandes de règlement au titre du RSSFP ni de vérifier l’état des
            demandes de règlement.
          </p>
          <p>
            Les activités de la Canada Vie ne sont pas touchées par cette
            interruption de service chez son sous-traitant. Toutes les demandes
            de règlement visant des frais engagés au Canada par les participants
            du RSSFP pour des soins non urgents et des frais engagés à
            l'étranger par les participants bénéficiant de la protection
            supplémentaire pour des soins non urgents doivent continuer d’être
            présentées à la Canada Vie.
          </p>
          <p>
            S’il s’avère qu’une personne a été touchée par l’incident, elle en
            sera informée directement.
          </p>
          <p>
            Nous sommes désolés de cet inconvénient et nous vous remercions
            sincèrement de votre patience et de votre compréhension pendant que
            nous travaillons à corriger la situation dans les plus brefs délais.
          </p>
          <p>Merci.</p>
          <p>MSH International</p>
          <p>
            <a
              href="https://www.bienvenue.canadavie.com/rssfp/msh-mise-a-jour.html"
              target="_blank"
            >
              Mise à jour MSH (canadavie.com)
            </a>
            <div>
              <a
                href="https://www.bienvenue.canadavie.com/rssfp/msh/msh-faq.html"
                target="_blank"
              >
                Foire aux questions
              </a>
            </div>
          </p>
        </div>
      </p>
    </div>
  );
};

export default AnnouncementFR;



// WEBPACK FOOTER //
// ./src/components/MemberPortal/AnnouncementFR.js